import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@features/auth/store/auth.store';

export const authGuard: CanActivateFn & CanActivateChildFn = () => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  const token = authStore.token();
  return token ? true : router.createUrlTree(['/login']);
};
